import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

const typographyDemo = {
    code:
`<div>
    <Typography use="headline1">headline1</Typography><br/>
    <Typography use="headline2">headline2</Typography><br/>
    <Typography use="headline3">headline3</Typography><br/>
    <Typography use="headline4">headline4</Typography><br/>
    <Typography use="headline5">headline5</Typography><br/>
    <Typography use="headline6">headline6</Typography><br/>
    <Typography use="subtitle1">subtitle1</Typography><br/>
    <Typography use="subtitle2">subtitle2</Typography><br/>
    <Typography use="body1">body1</Typography><br/>
    <Typography use="body2">body2</Typography><br/>
    <Typography use="caption">caption</Typography><br/>
    <Typography use="button">button</Typography><br/>
</div>`
};

export const TypographyDemo: FunctionComponent = () => {
    return (
        <Demo demo={typographyDemo}>
            <ComponentProps componentName="Typography" />
        </Demo>
    );
};

const anchorDemo = {
    code:
`<p>
    Here is <Anchor href="https://design.ep.se" target="_blank" >a link</Anchor> that opens a new tab to the DS website.
</p>`
};

export const AnchorDemo: FunctionComponent = () => {
    return (
        <Demo demo={anchorDemo}>
            <ComponentProps componentName="Anchor" />
        </Demo>
    );
};
